import { useEffect } from 'react';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../Context/authContext';
import { startAnalytics, identify, forget } from '../lib/insights';

export const usePostHog = () => {
  const { isLoggedIn, user } = useContextHook(AuthContext, v => ({
    isLoggedIn: v.isLoggedIn,
    user: v.user,
  }));

  useEffect(() => {
    startAnalytics();
  }, []);

  useEffect(() => {
    const data = user?.data ?? user;
    if (isLoggedIn && data?.id) {
      identify(data);
    } else if (!isLoggedIn) {
      forget();
    }
  }, [isLoggedIn, user?.data?.id ?? user?.id]);
};
